import React from "react";
import {OfferType} from "../../../../../../core/models/enums/offerType";
import {Images} from "../../../../../../core/utilities/images";
import "./OfferTrailing.scss";

interface IProps {
  offerType: OfferType;
}

const OfferTrailing = (props: IProps) => {

  const getSrc = (): string => {
    switch (props.offerType) {
      case OfferType.P2S:
      case OfferType.P2C:
      case OfferType.CONTINUE:
        return Images.icon_chevron_right_blue;
      case OfferType.J2F:
      case OfferType.J2F_S:
        return Images.icon_chevron_right_white;
      default:
        return "";
    }
  }

  return (
    props.offerType !== OfferType.GIVE_UP
      ? <img id="offer-trailing" src={getSrc()} alt="trailing"/>
      : <React.Fragment/>
  );
}

export default OfferTrailing;
